import { useParams, useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

function useURLParamsDynamically() {
  const routeParams = useParams();
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const queryParams = {};
    Array.from(searchParams.entries()).forEach(([key, value]) => {
      queryParams[key] = value;
    });

    return {
      ...queryParams,
      ...routeParams,
    };
  }, [routeParams, searchParams]);
}

export default useURLParamsDynamically;
